(function () {
  function getCategoriasBannerSection() {
    return document.querySelector(".categorias-banner-section") ||
      document.querySelector('[data-wsjs-sectitle*="categor"]') ||
      document.querySelector('[data-wsjs-sectitle*="Categoria"]') ||
      document.querySelector('[data-wsjs-sectitle*="Navegue por categorias"]');
  }

  function formatCategoriasBannerName(value) {
    return String(value || "")
      .replace(/\.[a-z0-9]+$/i, "")
      .replace(/[-_]+/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  function getCategoriasBannerName(link, image) {
    var name = "";
    var href = "";
    var fileName = "";

    if (image) {
      name = (image.getAttribute("alt") || image.getAttribute("title") || "").trim();
    }

    if (!name) {
      name = (
        link.getAttribute("alt") ||
        link.getAttribute("title") ||
        link.getAttribute("aria-label") ||
        link.getAttribute("data-banner-title") ||
        ""
      ).trim();
    }

    if (!name && image) {
      href = image.getAttribute("src") || "";
      fileName = href.split("/").pop().split("?")[0];
      name = formatCategoriasBannerName(fileName);
    }

    if (!name) {
      href = link.getAttribute("href") || "";
      fileName = href.split("/").filter(Boolean).pop() || "";
      name = formatCategoriasBannerName(decodeURIComponent(fileName));
    }

    return name;
  }

  function syncCategoriasBannerLabels() {
    var section = getCategoriasBannerSection();
    var links;

    if (!section) {
      return;
    }

    links = Array.from(section.querySelectorAll("a")).filter(function (link) {
      return !!link.querySelector("img");
    });

    links.forEach(function (link) {
      var image = link.querySelector("img");
      var name = getCategoriasBannerName(link, image);

      if (!name) {
        link.removeAttribute("data-banner-title");
        link.classList.remove("categorias-banner-with-label");
        return;
      }

      link.setAttribute("data-banner-title", name);
      link.classList.add("categorias-banner-with-label");
    });
  }

  function initCategoriasBannerLabels() {
    var section = getCategoriasBannerSection();
    var sectionObserver;
    var bodyObserver;
    var syncQueued = false;
    var retryTimer = null;
    var retryCount = 0;
    var maxRetries = 20;

    function queueSync() {
      if (syncQueued) {
        return;
      }

      syncQueued = true;
      requestAnimationFrame(function () {
        syncQueued = false;
        syncCategoriasBannerLabels();
      });
    }

    function scheduleRetry() {
      if (retryTimer || retryCount >= maxRetries) {
        return;
      }

      retryTimer = setTimeout(function () {
        retryTimer = null;
        retryCount += 1;
        queueSync();
        scheduleRetry();
      }, 500);
    }

    function attachToSection(el) {
      if (!el) {
        return;
      }

      if (el.dataset.categoriasBannerLabelsReady === "true") {
        queueSync();
        scheduleRetry();
        return;
      }

      el.dataset.categoriasBannerLabelsReady = "true";
      syncCategoriasBannerLabels();
      scheduleRetry();

      sectionObserver = new MutationObserver(queueSync);
      sectionObserver.observe(el, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["src", "alt", "title", "href", "aria-label", "data-banner-title"]
      });
    }

    if (section) {
      attachToSection(section);
      return;
    }

    bodyObserver = new MutationObserver(function () {
      var el = getCategoriasBannerSection();

      if (!el) {
        return;
      }

      bodyObserver.disconnect();
      attachToSection(el);
    });

    bodyObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCategoriasBannerLabels, { once: true });
  } else {
    initCategoriasBannerLabels();
  }

  window.addEventListener("load", initCategoriasBannerLabels);
  window.addEventListener("pageshow", initCategoriasBannerLabels);
})();

document.addEventListener('DOMContentLoaded', function () {
  function formatarPrecoProdutos() {
    /* Substituído por modulos_loja/card-price — mantido como no-op pra não brigar. */
    return;
    document.querySelectorAll('.prod-showcase-price-container').forEach(function (box) {
      const holder = box.closest('.prod-showcase-holder');
      const avista = box.querySelector('.prod-showcase-avista span');
      const blocoAvista = box.querySelector('.prod-showcase-avista');
      const mensagemIndisponivel = box.querySelector('.prod-unavaliable-message, .prod-consult-message');
      const isUnavailable = !!mensagemIndisponivel ||
        !!(holder && holder.matches('.unavailable, .unavaliable, .consult'));

      if (isUnavailable) {
        const precoRiscadoExistente = box.querySelector('.preco-normal-riscado');

        if (precoRiscadoExistente) {
          precoRiscadoExistente.remove();
        }

        box.querySelectorAll('.prod-showcase-price, .prod-showcase-price-sell, .prod-unavaliable-message, .prod-consult-message').forEach(function (item) {
          item.style.removeProperty('display');
        });

        return;
      }

      if (!avista || !blocoAvista) return;

      let precoRiscado = box.querySelector('.preco-normal-riscado');

      if (!precoRiscado) {
        precoRiscado = document.createElement('div');
        precoRiscado.className = 'preco-normal-riscado';
        box.insertBefore(precoRiscado, blocoAvista);
      }

      let valoresEncontrados = [];

      box.querySelectorAll('.prod-showcase-price, .prod-showcase-price-sell').forEach(function (item) {
        const texto = item.textContent || '';
        const valores = texto.match(/R\$\s*[\d.,]+/g);

        if (valores) {
          valores.forEach(function (valor) {
            const numero = Number(
              valor
                .replace('R$', '')
                .replace(/\s/g, '')
                .replace('.', '')
                .replace(',', '.')
            );

            if (!isNaN(numero)) {
              valoresEncontrados.push(numero);
            }
          });
        }
      });

      if (valoresEncontrados.length > 0) {
        const maiorValor = Math.max.apply(null, valoresEncontrados);

        precoRiscado.textContent = maiorValor.toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL'
        });
      }

      box.querySelectorAll('.prod-showcase-price, .prod-showcase-price-sell').forEach(function (item) {
        item.style.setProperty('display', 'none', 'important');
      });
    });
  }

  formatarPrecoProdutos();

  setTimeout(formatarPrecoProdutos, 500);
  setTimeout(formatarPrecoProdutos, 1500);
  setTimeout(formatarPrecoProdutos, 3000);
});

document.addEventListener('DOMContentLoaded', function () {
  function colocarNoPixDepoisDoPreco() {
    const containerPreco = document.querySelector('.prod-price-container');
    const precoPix = document.querySelector('.prod-price-container [data-wsjs-product="priceCash"]');

    if (!containerPreco || !precoPix) return false;

    /* Cria uma linha para deixar preço + NO PIX juntos */
    let linhaPix = containerPreco.querySelector('.linha-preco-pix-produto');

    if (!linhaPix) {
      linhaPix = document.createElement('div');
      linhaPix.className = 'linha-preco-pix-produto';

      precoPix.parentNode.insertBefore(linhaPix, precoPix);
    }

    if (precoPix.parentNode !== linhaPix) {
      linhaPix.appendChild(precoPix);
    }

    containerPreco.querySelectorAll('.tag-pix-produto, .tag-no-pix-produto').forEach(function (tag) {
      if (tag.parentNode !== linhaPix) {
        tag.remove();
      }
    });

    /* Adiciona o NO PIX depois do preço, com o desconto PIX do JSON */
    let tagPix = linhaPix.querySelector('.tag-no-pix-produto');

    if (!tagPix) {
      tagPix = document.createElement('span');
      tagPix.className = 'tag-no-pix-produto';
      tagPix.style.display = 'none';
      linhaPix.appendChild(tagPix);
    }

    /* Busca o cash_discount diretamente do JSON do produto */
    var infoProduto = null;
    try {
      infoProduto = wsMain && wsMain.globalData && wsMain.globalData.infoProduto;
    } catch (e) {}

    if (infoProduto && infoProduto.cash_discount) {
      tagPix.textContent = '-' + infoProduto.cash_discount + '% NO PIX';
      tagPix.style.display = '';
      return true;
    }

    /* Fallback: tenta desconto_avista */
    if (infoProduto && infoProduto.precos && infoProduto.precos.desconto_avista) {
      tagPix.textContent = '-' + infoProduto.precos.desconto_avista + '% NO PIX';
      tagPix.style.display = '';
      return true;
    }

    tagPix.style.display = 'none';
    return false;
  }

  /* Tenta imediatamente */
  if (colocarNoPixDepoisDoPreco()) return;

  /* Se não conseguiu, observa o DOM até os dados do produto estarem disponíveis */
  var observer = new MutationObserver(function () {
    if (colocarNoPixDepoisDoPreco()) {
      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });

  /* Fallback de segurança: desconecta o observer após 10s para não ficar rodando infinitamente */
  setTimeout(function () {
    observer.disconnect();
    colocarNoPixDepoisDoPreco();
  }, 10000);
});


document.addEventListener('DOMContentLoaded', function () {
  function ajustarFavoritoNaLinhaDoCodigo() {
    const codeContainer = document.querySelector('.prod-code-container');
    const favButton = document.querySelector(
      '.prod-social-container button[id^="prod-favorite-link"], button[data-wsjs-product="buttonFavorite"]'
    );

    if (!codeContainer || !favButton) return;

    codeContainer.appendChild(favButton);

    codeContainer.style.setProperty('display', 'flex', 'important');
    codeContainer.style.setProperty('align-items', 'center', 'important');
    codeContainer.style.setProperty('justify-content', 'space-between', 'important');
    codeContainer.style.setProperty('width', '100%', 'important');
    codeContainer.style.setProperty('max-width', '100%', 'important');
    codeContainer.style.setProperty('position', 'relative', 'important');

    favButton.style.setProperty('position', 'static', 'important');
    favButton.style.setProperty('margin-left', 'auto', 'important');
    favButton.style.setProperty('margin-right', '0', 'important');
    favButton.style.setProperty('padding', '0', 'important');
    favButton.style.setProperty('background', 'transparent', 'important');
    favButton.style.setProperty('border', '0', 'important');
    favButton.style.setProperty('display', 'flex', 'important');
    favButton.style.setProperty('align-items', 'center', 'important');
    favButton.style.setProperty('justify-content', 'center', 'important');
    favButton.style.setProperty('width', '22px', 'important');
    favButton.style.setProperty('height', '22px', 'important');
    favButton.style.setProperty('cursor', 'pointer', 'important');

    const svg = favButton.querySelector('svg');
    if (svg) {
      svg.style.setProperty('width', '18px', 'important');
      svg.style.setProperty('height', '18px', 'important');
    }

    const socialContainer = document.querySelector('.prod-social-container');
    if (socialContainer) {
      socialContainer.style.setProperty('display', 'contents', 'important');
    }
  }

  ajustarFavoritoNaLinhaDoCodigo();

  setTimeout(ajustarFavoritoNaLinhaDoCodigo, 500);
  setTimeout(ajustarFavoritoNaLinhaDoCodigo, 1000);
});

document.addEventListener('DOMContentLoaded', function () {
  function removerTextoAvista() {
    document.querySelectorAll('.prod-showcase-avista span').forEach(function(span) {
      span.innerHTML = span.innerHTML.replace(/\s*à vista/gi, '');
    });
  }

  removerTextoAvista();

  setTimeout(removerTextoAvista, 500);
  setTimeout(removerTextoAvista, 1500);
});

(function () {
  function mostrarInfoSomenteCategoriaVazia() {
    const categoriaVazia = document.querySelector('.category-search-list .prod-list-empty');

    if (!categoriaVazia) {
      return;
    }

    const seletores = [
      '.category-search-list',
      '.category-search-list .custom-filters-container',
      '.category-search-list .breadcrumb-container',
      '.category-search-list .custom-breadcrumb',
      '#banner-category_description',
      '#banner-category_description > div',
      '#banner-category_description h1',
      '#banner-category_description h2',
      '#banner-category_description p'
    ];

    seletores.forEach(function (seletor) {
      document.querySelectorAll(seletor).forEach(function (el) {
        el.style.setProperty('display', 'block', 'important');
        el.style.setProperty('visibility', 'visible', 'important');
        el.style.setProperty('opacity', '1', 'important');
        el.style.setProperty('height', 'auto', 'important');
        el.style.setProperty('min-height', 'auto', 'important');
        el.style.setProperty('max-height', 'none', 'important');
        el.style.setProperty('overflow', 'visible', 'important');
        el.style.setProperty('position', 'relative', 'important');
        el.style.setProperty('z-index', '2', 'important');
      });
    });

    const filtros = document.querySelector('.category-search-list .custom-filters-container');

    if (filtros) {
      filtros.style.setProperty('padding', '30px 0 20px', 'important');
      filtros.style.setProperty('margin', '0 auto', 'important');
      filtros.style.setProperty('width', '100%', 'important');
    }

    const breadcrumb = document.querySelector('.category-search-list .breadcrumb-container');

    if (breadcrumb) {
      breadcrumb.style.setProperty('margin-bottom', '20px', 'important');
    }

    const descricao = document.querySelector('#banner-category_description');

    if (descricao) {
      descricao.style.setProperty('margin-bottom', '30px', 'important');
    }
  }

  document.addEventListener('DOMContentLoaded', mostrarInfoSomenteCategoriaVazia);
  window.addEventListener('load', mostrarInfoSomenteCategoriaVazia);

  setTimeout(mostrarInfoSomenteCategoriaVazia, 500);
  setTimeout(mostrarInfoSomenteCategoriaVazia, 1500);
})();


(function () {
  function criarTituloCategoriaVazia() {
    const categoriaVazia = document.querySelector('.category-search-list .prod-list-empty');

    if (!categoriaVazia) return;

    const areaCategoria = document.querySelector('.category-search-list .custom-filters-container');
    const breadcrumbContainer = document.querySelector('.category-search-list .breadcrumb-container');

    if (!areaCategoria || !breadcrumbContainer) return;

    let nomeCategoria = '';

    const links = breadcrumbContainer.querySelectorAll('a');

    if (links.length) {
      nomeCategoria = links[links.length - 1].textContent.trim();
    }

    if (!nomeCategoria) {
      nomeCategoria = breadcrumbContainer.textContent.split('/').pop().trim();
    }

    if (!nomeCategoria) return;

    let titulo = document.querySelector('.titulo-categoria-vazia');

    if (!titulo) {
      titulo = document.createElement('h1');
      titulo.className = 'titulo-categoria-vazia';
      titulo.textContent = nomeCategoria;

      breadcrumbContainer.insertAdjacentElement('afterend', titulo);
    }

    titulo.textContent = nomeCategoria;
  }

  document.addEventListener('DOMContentLoaded', criarTituloCategoriaVazia);
  window.addEventListener('load', criarTituloCategoriaVazia);

  setTimeout(criarTituloCategoriaVazia, 500);
  setTimeout(criarTituloCategoriaVazia, 1500);
})();

(function () {
  function corrigirMeiaEstrelaProduto() {
    document.querySelectorAll('#stars-in-prod-desc .half-star').forEach(function (halfStar, index) {
      const svg = halfStar.querySelector('svg');
      const path = halfStar.querySelector('path');

      if (!svg || !path) return;

      const gradientId = 'half-star-prod-desc-' + index;

      let defs = svg.querySelector('defs');

      if (!defs) {
        defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
        svg.insertBefore(defs, svg.firstChild);
      }

      let gradient = svg.querySelector('#' + gradientId);

      if (!gradient) {
        gradient = document.createElementNS('http://www.w3.org/2000/svg', 'linearGradient');
        gradient.setAttribute('id', gradientId);
        gradient.setAttribute('x1', '0%');
        gradient.setAttribute('y1', '0%');
        gradient.setAttribute('x2', '100%');
        gradient.setAttribute('y2', '0%');

        const stop1 = document.createElementNS('http://www.w3.org/2000/svg', 'stop');
        stop1.setAttribute('offset', '50%');
        stop1.setAttribute('stop-color', '#FFC400');

        const stop2 = document.createElementNS('http://www.w3.org/2000/svg', 'stop');
        stop2.setAttribute('offset', '50%');
        stop2.setAttribute('stop-color', '#E5E5E5');

        gradient.appendChild(stop1);
        gradient.appendChild(stop2);
        defs.appendChild(gradient);
      }

      halfStar.style.setProperty('display', 'inline-flex', 'important');
      halfStar.style.setProperty('width', '15px', 'important');
      halfStar.style.setProperty('height', '15px', 'important');
      halfStar.style.setProperty('overflow', 'visible', 'important');

      svg.style.setProperty('display', 'block', 'important');
      svg.style.setProperty('width', '15px', 'important');
      svg.style.setProperty('height', '15px', 'important');
      svg.style.setProperty('overflow', 'visible', 'important');

      path.style.setProperty('display', 'block', 'important');
      path.style.setProperty('visibility', 'visible', 'important');
      path.style.setProperty('opacity', '1', 'important');
      path.style.setProperty('fill', 'url(#' + gradientId + ')', 'important');
    });
  }

  document.addEventListener('DOMContentLoaded', corrigirMeiaEstrelaProduto);
  window.addEventListener('load', corrigirMeiaEstrelaProduto);

  setTimeout(corrigirMeiaEstrelaProduto, 300);
  setTimeout(corrigirMeiaEstrelaProduto, 800);
  setTimeout(corrigirMeiaEstrelaProduto, 1500);
})();


/* Abrir/fechar do filtro lateral (.aba-lateral-conteudo) — só mexe no
   `checked` do checkbox; toda a animação (transform/overlay) é 100% CSS
   (custom-listagem.css, seletor #aba-lateral-input:checked ~ ...), igual ao
   carrinho/login/parcelas. Antes existiam DUAS implementações duplicadas
   aqui que forçavam transform/opacity/visibility/pointer-events via
   el.style.setProperty(..., 'important') diretamente no elemento — um
   estilo inline com !important vence QUALQUER regra de CSS externo
   (mesmo !important), então nenhuma mudança de animação feita em
   custom-listagem.css chegava a ter efeito: o painel sempre pulava de
   opacity:0/1 sem transição real, brigando com o cartão flutuante novo.
   Consolidado numa única implementação que só reflete o estado no
   checkbox — sem inline style nenhum. */
document.addEventListener('DOMContentLoaded', function () {
  function fecharFiltroCategoria() {
    const input = document.querySelector('#aba-lateral-input');
    if (input) input.checked = false;
  }

  function abrirFiltroCategoria() {
    const input = document.querySelector('#aba-lateral-input');
    if (input) input.checked = true;
  }

  document.addEventListener('click', function (e) {
    const clicouFecharFiltro = e.target.closest(
      '.category-search-list .aba-lateral-botao-fechar, .category-search-list .aba-lateral-botao-fechar *, .category-search-list .fundo-escuro'
    );

    const clicouAbrirFiltro = e.target.closest(
      '.category-search-list .custom-filters-btn-wrapper .aba-lateral-botao, .category-search-list label[for="aba-lateral-input"]:not(.aba-lateral-botao-fechar)'
    );

    const clicouCarrinho = e.target.closest(
      '[data-wsjs-cart], [data-cart], .header-cart, .cart-button, .cart-icon, .cart-container, .mini-cart, [class*="cart"], [class*="carrinho"]'
    );

    if (clicouCarrinho || clicouFecharFiltro) {
      fecharFiltroCategoria();
      return;
    }

    if (clicouAbrirFiltro) {
      e.preventDefault();
      e.stopPropagation();
      abrirFiltroCategoria();
    }
  }, true);

  fecharFiltroCategoria();
});

function ajustarEspacamentoCategoriasBanners() {
  document
    .querySelectorAll('.categorias-banners-carousel .keen-slider__slide')
    .forEach(slide => {
      const transformAtual = slide.style.transform;

      if (!transformAtual) return;

      if (transformAtual.includes('translate3d(50px')) {
        slide.style.transform = transformAtual.replace(
          'translate3d(50px',
          'translate3d(40px'
        );
      }

      if (transformAtual.includes('translate3d(0px')) {
        slide.style.transform = transformAtual.replace(
          'translate3d(0px',
          'translate3d(10px'
        );
      }
    });
}

window.addEventListener('load', () => {
  ajustarEspacamentoCategoriasBanners();

  setTimeout(ajustarEspacamentoCategoriasBanners, 500);
  setTimeout(ajustarEspacamentoCategoriasBanners, 1000);
  setTimeout(ajustarEspacamentoCategoriasBanners, 2000);
});



function ajustarCardsSemEstrelasCategoria() {
  document
    .querySelectorAll('section[data-wsjs-sectype="prod-list-category"] .prod-showcase-holder')
    .forEach(card => {
      const temEstrela = card.querySelector('.ws-review-star-container');

      if (!temEstrela) {
        card.classList.add('sem-estrelas');
      } else {
        card.classList.remove('sem-estrelas');
      }
    });
}

document.addEventListener('DOMContentLoaded', () => {
  ajustarCardsSemEstrelasCategoria();

  setTimeout(ajustarCardsSemEstrelasCategoria, 500);
  setTimeout(ajustarCardsSemEstrelasCategoria, 1000);
  setTimeout(ajustarCardsSemEstrelasCategoria, 2000);

  const observerCardsCategoria = new MutationObserver(() => {
    ajustarCardsSemEstrelasCategoria();
  });

  observerCardsCategoria.observe(document.body, {
    childList: true,
    subtree: true
  });
});


document.addEventListener('DOMContentLoaded', () => {
  document.querySelector('#ajuste-descer-miniaturas-produto')?.remove();

  const style = document.createElement('style');
  style.id = 'ajuste-descer-miniaturas-produto';

  style.innerHTML = `
    .prod-photo-container > div[data-wsjs-product="dots"],
    .prod-photo-container [data-wsjs-product="dots"].slide-container {
      position: relative !important;
      top: -125px !important;
    }
  `;

  document.head.appendChild(style);
});

/* Garantir código do produto em todos os cards, inclusive quando o template publicado
   chega sem a div pronta ou quando os cards são montados depois do carregamento inicial. */
(function () {
  function ensureProductCode(card) {
    if (!card || card.dataset.prodCodeBound === 'true') return;

    var sku = card.getAttribute('ws-prod-sku') ||
              card.getAttribute('data-prod-sku');

    if (!sku || !sku.trim()) return;

    var infoDiv = card.querySelector('.prod-showcase-info');
    if (!infoDiv) return;

    var codeDiv = card.querySelector('.prod-showcase-code');
    var nameDiv = card.querySelector('.prod-showcase-info-name');

    if (!codeDiv) {
      codeDiv = document.createElement('div');
      codeDiv.className = 'prod-showcase-code';

      if (nameDiv) {
        infoDiv.insertBefore(codeDiv, nameDiv);
      } else {
        infoDiv.insertBefore(codeDiv, infoDiv.firstChild);
      }
    }

    if (!codeDiv.querySelector('span')) {
      var span = document.createElement('span');
      codeDiv.innerHTML = '';
      codeDiv.appendChild(span);
    }

    codeDiv.querySelector('span').textContent = 'CÓD.: ' + sku.trim();
    codeDiv.style.display = '';
    card.dataset.prodCodeBound = 'true';
  }

  function ensureAllProductCodes(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.prod-showcase-holder').forEach(ensureProductCode);
  }

  function scheduleEnsureAll(root) {
    window.requestAnimationFrame(function () {
      ensureAllProductCodes(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      ensureAllProductCodes(document);
    });
  } else {
    ensureAllProductCodes(document);
  }

  window.addEventListener('load', function () {
    ensureAllProductCodes(document);
  });

  var observerCodigoProdutos = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (!node || node.nodeType !== 1) return;

        if (node.matches && node.matches('.prod-showcase-holder')) {
          ensureProductCode(node);
          return;
        }

        if (node.querySelector) {
          scheduleEnsureAll(node);
        }
      });
    });
  });

  observerCodigoProdutos.observe(document.documentElement || document.body, {
    childList: true,
    subtree: true
  });
})();




(function () {
  var selectedUnavailableProduct = null;
  var previousInfoProduto = null;

  function getAllStoreProducts() {
    var globalData = window.wsMain && wsMain.globalData;
    var products = [];

    function addProduct(product) {
      if (product && typeof product === 'object') {
        products.push(product);
      }
    }

    function addProductList(list) {
      if (Array.isArray(list)) {
        list.forEach(addProduct);
      }
    }

    addProduct(globalData && globalData.infoProduto);
    addProductList(globalData && globalData.listHomeProds && globalData.listHomeProds.produtos);
    addProductList(globalData && globalData.listCategoryProds && globalData.listCategoryProds.produtos);
    addProductList(globalData && globalData.listRelatedProds);
    addProductList(globalData && globalData.listLastProds);

    if (globalData && globalData.listGroupProds && Array.isArray(globalData.listGroupProds.grupos)) {
      globalData.listGroupProds.grupos.forEach(function (group) {
        addProductList(group && group.produtos);
      });
    }

    return products;
  }

  function getProductFromCard(card) {
    var sku = (card.getAttribute('ws-prod-sku') || card.getAttribute('data-prod-sku') || '').trim();
    var product = getAllStoreProducts().find(function (item) {
      return String(item.codigo || item.cod || item.sku || '').trim() === sku;
    }) || null;
    var image = card.querySelector('.prod-showcase-image img, img');
    var nameNode = card.querySelector('.prod-showcase-info-name');
    var link = card.querySelector('.prod-showcase-link-overlay[href], .prod-showcase-image a[href], a[href]');

    return {
      sku: sku,
      product: product,
      name: (product && (product.nome || product.name)) || (nameNode && nameNode.textContent.trim()) || '',
      image: (product && (product.imagem || product.foto || product.image)) || (image && image.getAttribute('src')) || '',
      url: (product && (product.url || product.link)) || (link && link.getAttribute('href')) || ''
    };
  }

  function getUnavailableModal() {
    var modal = document.querySelector('.unavailable-product-modal');

    if (modal) {
      return modal;
    }

    modal = document.createElement('div');
    modal.className = 'unavailable-product-modal';
    modal.setAttribute('aria-hidden', 'true');
    modal.innerHTML = [
      '<div class="unavailable-product-modal__backdrop" data-unavailable-close></div>',
      '<button class="unavailable-product-modal__close" type="button" aria-label="Fechar" data-unavailable-close></button>',
      '<div class="unavailable-product-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="unavailable-product-modal-title">',
      '  <div class="unavailable-product-modal__image"><img alt=""></div>',
      '  <div class="unavailable-product-modal__content">',
      '    <h2 id="unavailable-product-modal-title">Produto indispon&iacute;vel</h2>',
      '    <p>Informe seus dados que iremos te avisar assim que este produto estiver dispon&iacute;vel.</p>',
      '    <div class="contact-message-container unavailable-product-modal__message" style="display:none; opacity:0;">',
      '      <div class="contact-message"></div>',
      '    </div>',
      '    <form id="contact-form" class="unavailable-product-modal__form" data-wsjs-contact="container">',
      '      <input data-wsjs-contact="Nome" type="text" maxlength="50" required placeholder="Seu nome">',
      '      <input data-wsjs-contact="Telefone" type="text" maxlength="20" required placeholder="Seu WhatsApp">',
      '      <input data-wsjs-contact="E-mail" type="email" maxlength="50" required placeholder="Seu e-mail">',
      '      <input data-wsjs-contact="Assunto" type="hidden">',
      '      <textarea data-wsjs-contact="Messagem" hidden></textarea>',
      '      <button class="button-third unavailable-product-modal__submit" type="submit">Avise quando chegar</button>',
      '    </form>',
      '  </div>',
      '</div>'
    ].join('');

    document.body.appendChild(modal);

    modal.addEventListener('click', function (event) {
      if (event.target.closest('[data-unavailable-close]')) {
        closeUnavailableModal();
      }
    });

    modal.querySelector('form').addEventListener('submit', submitUnavailableModal);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal.classList.contains('is-open')) {
        closeUnavailableModal();
      }
    });

    return modal;
  }

  function setModalMessage(modal, message, isError) {
    var container = modal.querySelector('.contact-message-container');
    var messageBox = modal.querySelector('.contact-message');

    if (!container || !messageBox) {
      return;
    }

    messageBox.innerHTML = message;
    container.style.display = 'block';
    container.style.opacity = '1';
    container.classList.toggle('is-error', !!isError);
  }

  function prepareModalFormForNativeSubmit(form) {
    document.querySelectorAll('#contact-form').forEach(function (otherForm) {
      if (otherForm === form) {
        return;
      }

      otherForm.setAttribute('data-unavailable-previous-id', otherForm.id);
      otherForm.removeAttribute('id');
    });

    document.querySelectorAll('[data-wsjs-contact="container"]').forEach(function (otherForm) {
      if (otherForm === form) {
        return;
      }

      otherForm.setAttribute('data-unavailable-previous-contact-container', 'true');
      otherForm.removeAttribute('data-wsjs-contact');
    });

    form.id = 'contact-form';
    form.setAttribute('data-wsjs-contact', 'container');
  }

  function restoreNativeContactForms() {
    document.querySelectorAll('[data-unavailable-previous-id]').forEach(function (form) {
      form.id = form.getAttribute('data-unavailable-previous-id');
      form.removeAttribute('data-unavailable-previous-id');
    });

    document.querySelectorAll('[data-unavailable-previous-contact-container]').forEach(function (form) {
      form.setAttribute('data-wsjs-contact', 'container');
      form.removeAttribute('data-unavailable-previous-contact-container');
    });
  }

  function openUnavailableModal(card) {
    var modal = getUnavailableModal();
    var data = getProductFromCard(card);
    var image = modal.querySelector('.unavailable-product-modal__image img');
    var subject = modal.querySelector('[data-wsjs-contact="Assunto"]');
    var message = modal.querySelector('[data-wsjs-contact="Messagem"]');
    var messageContainer = modal.querySelector('.contact-message-container');

    selectedUnavailableProduct = data;

    if (image) {
      image.src = data.image || '';
      image.alt = data.name || 'Produto indispon&iacute;vel';
      image.parentElement.style.display = data.image ? '' : 'none';
    }

    modal.querySelector('form').reset();

    if (subject) {
      subject.value = 'Avise quando chegar - ' + (data.name || data.sku || 'Produto');
    }

    if (message) {
      message.value = [
        'Tenho interesse neste produto indispon&iacute;vel.',
        data.name ? 'Produto: ' + data.name : '',
        data.sku ? 'C&oacute;digo: ' + data.sku : '',
        data.url ? 'Link: ' + data.url : ''
      ].filter(Boolean).join('\n');
    }

    if (messageContainer) {
      messageContainer.style.display = 'none';
      messageContainer.style.opacity = '0';
    }

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('unavailable-product-modal-open');
    setTimeout(function () {
      var firstInput = modal.querySelector('input:not([type="hidden"])');
      if (firstInput) firstInput.focus();
    }, 60);
  }

  function closeUnavailableModal() {
    var modal = document.querySelector('.unavailable-product-modal');

    if (!modal) {
      return;
    }

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('unavailable-product-modal-open');

    if (previousInfoProduto && window.wsMain && wsMain.globalData) {
      wsMain.globalData.infoProduto = previousInfoProduto;
      previousInfoProduto = null;
    }

    restoreNativeContactForms();
  }

  function submitUnavailableModal(event) {
    var modal = getUnavailableModal();
    var nativeSubmit = window.wsMain && wsMain.modules && wsMain.modules['pag-produto'] && wsMain.modules['pag-produto'].sendNotificationForm;

    event.preventDefault();

    if (!event.currentTarget.checkValidity()) {
      event.currentTarget.reportValidity();
      return false;
    }

    if (selectedUnavailableProduct && selectedUnavailableProduct.product && window.wsMain && wsMain.globalData) {
      previousInfoProduto = wsMain.globalData.infoProduto;
      wsMain.globalData.infoProduto = selectedUnavailableProduct.product;
    }

    if (typeof nativeSubmit === 'function') {
      try {
        prepareModalFormForNativeSubmit(event.currentTarget);
        nativeSubmit.call(wsMain.modules['pag-produto']);
        setModalMessage(modal, 'Solicita&ccedil;&atilde;o enviada com sucesso.', false);
        event.currentTarget.reset();
      } catch (error) {
        setModalMessage(modal, 'N&atilde;o foi poss&iacute;vel enviar agora. Tente novamente em instantes.', true);
      }
      return false;
    }

    setModalMessage(modal, 'N&atilde;o foi poss&iacute;vel enviar agora. Tente novamente pela p&aacute;gina do produto.', true);
    return false;
  }

  document.addEventListener('click', function (event) {
    var card = event.target.closest('.prod-showcase-holder.unavailable, .prod-showcase-holder.unavaliable');
    var ignored = event.target.closest('.prod-showcase-favorite, [data-wsjs-prod-template="favorite"]');

    if (!card || ignored) {
      return;
    }

    // Verificar se clicou no botão "Avise quando chegar" (parte inferior do link overlay)
    var linkOverlay = event.target.closest('.prod-showcase-link-overlay.unavailable, .prod-showcase-link-overlay.unavaliable');
    var infoButton = event.target.closest('.prod-showcase-info-button');

    if (infoButton) {
      event.preventDefault();
      event.stopPropagation();
      openUnavailableModal(card);
      return;
    }

    if (linkOverlay) {
      // Verificar se o click foi na área do botão (últimos 55px do card)
      var rect = linkOverlay.getBoundingClientRect();
      var clickY = event.clientY;
      var bottomArea = rect.bottom - 55;

      if (clickY >= bottomArea) {
        // Clicou na área do botão "Avise quando chegar"
        event.preventDefault();
        event.stopPropagation();
        openUnavailableModal(card);
        return;
      }

      // Clicou fora do botão - navegar para o produto
      var data = getProductFromCard(card);
      if (data.url && data.url !== 'javascript:;' && data.url !== 'javascript:void(0)') {
        event.preventDefault();
        event.stopPropagation();
        window.location.href = data.url;
        return;
      }
    }
  }, true);
})();









/* Validação do popup "Avise quando chegar" - máscara, limite e validação */
(function () {
  function initValidacaoAviseChegar() {
    var modal = document.querySelector(".unavailable-product-modal");
    if (!modal) return;

    var inputs = modal.querySelectorAll("input");
    var inputNome = null;
    var inputWhatsapp = null;
    var inputEmail = null;

    inputs.forEach(function (input) {
      var placeholder = (input.getAttribute("placeholder") || "").toLowerCase();
      var type = (input.getAttribute("type") || "").toLowerCase();
      var name = (input.getAttribute("name") || "").toLowerCase();

      if (placeholder.indexOf("nome") !== -1 || name.indexOf("nome") !== -1 || name.indexOf("name") !== -1) {
        inputNome = input;
      } else if (placeholder.indexOf("whatsapp") !== -1 || placeholder.indexOf("celular") !== -1 || placeholder.indexOf("telefone") !== -1 || name.indexOf("phone") !== -1 || name.indexOf("whatsapp") !== -1 || name.indexOf("celular") !== -1) {
        inputWhatsapp = input;
      } else if (type === "email" || placeholder.indexOf("e-mail") !== -1 || placeholder.indexOf("email") !== -1 || name.indexOf("email") !== -1) {
        inputEmail = input;
      }
    });

    /* Limite de caracteres no nome */
    if (inputNome) {
      inputNome.setAttribute("maxlength", "60");
    }

    /* Máscara de celular com DDD: (XX) XXXXX-XXXX */
    if (inputWhatsapp) {
      inputWhatsapp.setAttribute("maxlength", "15");
      inputWhatsapp.setAttribute("inputmode", "numeric");

      inputWhatsapp.addEventListener("input", function () {
        var valor = inputWhatsapp.value.replace(/\D/g, "");

        if (valor.length > 11) {
          valor = valor.substring(0, 11);
        }

        if (valor.length > 7) {
          valor = "(" + valor.substring(0, 2) + ") " + valor.substring(2, 7) + "-" + valor.substring(7);
        } else if (valor.length > 2) {
          valor = "(" + valor.substring(0, 2) + ") " + valor.substring(2);
        } else if (valor.length > 0) {
          valor = "(" + valor;
        }

        inputWhatsapp.value = valor;
      });
    }

    /* Validação de e-mail */
    if (inputEmail) {
      inputEmail.setAttribute("maxlength", "80");

      inputEmail.addEventListener("blur", function () {
        var valor = inputEmail.value.trim();
        if (!valor) return;

        var valido = validarEmail(valor);
        if (!valido) {
          inputEmail.style.borderColor = "#D92A1C";
        } else {
          inputEmail.style.borderColor = "";
        }
      });

      inputEmail.addEventListener("input", function () {
        inputEmail.style.borderColor = "";
      });
    }

    /* Intercepta envio do formulário para validar */
    var form = modal.querySelector("form");
    var btnSubmit = modal.querySelector("button[type='submit'], .unavailable-product-modal__submit, button:not(.unavailable-product-modal__close)");

    if (form) {
      form.addEventListener("submit", function (e) {
        if (!validarFormulario(inputNome, inputWhatsapp, inputEmail)) {
          e.preventDefault();
          e.stopPropagation();
        }
      });
    } else if (btnSubmit) {
      btnSubmit.addEventListener("click", function (e) {
        if (!validarFormulario(inputNome, inputWhatsapp, inputEmail)) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);
    }
  }

  function validarEmail(email) {
    if (!email) return false;
    if (email.indexOf("@") === -1) return false;

    var partes = email.split("@");
    if (partes.length !== 2) return false;
    if (!partes[0] || partes[0].length === 0) return false;
    if (!partes[1] || partes[1].length === 0) return false;

    var dominio = partes[1];
    if (dominio.indexOf(".") === -1) return false;

    var partesdominio = dominio.split(".");
    var ultimaParte = partesdominio[partesdominio.length - 1];
    if (!ultimaParte || ultimaParte.length < 2) return false;

    return true;
  }

  function validarFormulario(inputNome, inputWhatsapp, inputEmail) {
    var erros = [];

    if (inputNome && inputNome.value.trim().length < 3) {
      erros.push("Nome precisa ter pelo menos 3 caracteres.");
      inputNome.style.borderColor = "#D92A1C";
    }

    if (inputWhatsapp) {
      var numeros = inputWhatsapp.value.replace(/\D/g, "");
      if (numeros.length < 10 || numeros.length > 11) {
        erros.push("Informe um celular válido com DDD.");
        inputWhatsapp.style.borderColor = "#D92A1C";
      }
    }

    if (inputEmail && !validarEmail(inputEmail.value.trim())) {
      erros.push("Informe um e-mail válido.");
      inputEmail.style.borderColor = "#D92A1C";
    }

    if (erros.length > 0) {
      alert(erros.join("\n"));
      return false;
    }

    return true;
  }

  /* Observa o DOM para quando o modal abrir */
  function observarModal() {
    var observer = new MutationObserver(function () {
      var modal = document.querySelector(".unavailable-product-modal.is-open");
      if (modal && !modal.dataset.validacaoAplicada) {
        modal.dataset.validacaoAplicada = "true";
        initValidacaoAviseChegar();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class"]
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", observarModal);
  } else {
    observarModal();
  }
})();

/* Corrigir links do menu de categorias: transformar href="javascript:;" em links reais */
(function () {
  function corrigirLinksMenuCategorias() {
    var menuList = document.querySelector('header .nav-header .nav-menu-list');
    if (!menuList) return;

    // Corrigir TODOS os links com javascript:; no menu (inclusive dentro do Mais categorias)
    var links = menuList.querySelectorAll('a.nav-menu-hiperlink[href="javascript:;"], a.nav-menu-hiperlink[href="javascript:void(0)"]');

    links.forEach(function (link) {
      var li = link.closest('li');
      if (!li) return;

      // Tentar encontrar qualquer subcategoria com link real dentro deste li
      var subLink = li.querySelector('.nav-menu-sub-container a[href]:not([href^="javascript"]), .nav-menu-main a[href]:not([href^="javascript"]), .nav-menu-sub-list a[href]:not([href^="javascript"])');
      
      if (subLink) {
        var subHref = subLink.getAttribute('href') || '';
        var partes = subHref.split('/').filter(Boolean);
        
        // Formato URL: /slug-categoria/id-categoria/slug-subcategoria
        // Pegamos: /slug-categoria/id-categoria
        if (partes.length >= 2) {
          link.setAttribute('href', '/' + partes[0] + '/' + partes[1]);
        } else if (partes.length === 1) {
          link.setAttribute('href', '/' + partes[0]);
        }
      }
    });
  }

  try {
    isReady("categorias", corrigirLinksMenuCategorias);
  } catch (e) {}

  document.addEventListener('DOMContentLoaded', corrigirLinksMenuCategorias);
  window.addEventListener('load', corrigirLinksMenuCategorias);
  setTimeout(corrigirLinksMenuCategorias, 500);
  setTimeout(corrigirLinksMenuCategorias, 1500);
})();

/* Botão "Faça seu login" nos cards sob consulta deve abrir o popup de login */
(function () {
  document.addEventListener('click', function (event) {
    var card = event.target.closest('.prod-showcase-holder.consult');
    if (!card) return;

    var linkOverlay = event.target.closest('.prod-showcase-link-overlay.consult');
    if (!linkOverlay) return;

    // Verificar se clicou na área do botão (últimos 55px do card)
    var rect = linkOverlay.getBoundingClientRect();
    var clickY = event.clientY;
    var bottomArea = rect.bottom - 55;

    if (clickY >= bottomArea) {
      event.preventDefault();
      event.stopPropagation();

      // Abrir o popup de login
      var popup = document.querySelector('.ws-new-popup-login__popup-wrapper');
      if (popup) {
        popup.classList.remove('login-popup-disabled');
        popup.classList.add('login-popup-active');
      } else {
        // Fallback: clicar no botão de login do header
        var loginBtn = document.querySelector('.ws-new-popup-login__anchor, #openModalBtn');
        if (loginBtn) loginBtn.click();
      }
      return;
    }

    // Clicou fora do botão - navegar para o produto
    var link = card.querySelector('.prod-showcase-link-overlay[href], a[href]');
    var url = link ? link.getAttribute('href') : '';
    if (url && url !== 'javascript:;' && url !== 'javascript:void(0)') {
      event.preventDefault();
      event.stopPropagation();
      window.location.href = url;
    }
  }, true);
})();

/* Menu do usuário logado: migração v2→v3 — agora é o dropdown nativo de
 * wsapi3-login-options (.login-options-container:hover .login-options-list),
 * já presente no markup do topo.html. Popup .user-logged-menu removido. */


/* Produtos relacionados na página de produto: click em qualquer parte do bloco abre o produto */
(function () {
  document.addEventListener('click', function (event) {
    var relatedContainer = event.target.closest('.prod-related-container, #code-list-relacionados');
    if (!relatedContainer) return;

    var card = event.target.closest('.prod-showcase-holder');
    if (!card) return;

    // Ignorar favoritos
    var ignored = event.target.closest('.prod-showcase-favorite, [data-wsjs-prod-template="favorite"]');
    if (ignored) return;

    // Buscar URL do produto
    var link = card.querySelector('.prod-showcase-link-overlay[href], .prod-showcase-image a[href], a[href]');
    var url = link ? link.getAttribute('href') : '';

    if (url && url !== 'javascript:;' && url !== 'javascript:void(0)') {
      event.preventDefault();
      event.stopPropagation();
      window.location.href = url;
    }
  }, true);
})();

/* Acrescentar valor de venda na linha de parcelamento: "ou R$ X em Nx de R$ Y sem juros" */
(function () {
  function ajustarTextoParcela() {
    document.querySelectorAll('.prod-showcase-parcela, .prod-showcase-holder .prod-showcase-parcela').forEach(function (parcela) {
      if (parcela.dataset.parcelaAjustada === 'true') return;

      var texto = parcela.textContent.trim();
      var match = texto.match(/^(ou\s*)?(\d+)x\s*de\s*(R\$\s*[\d.,]+)\s*(sem juros)?/i);
      if (!match) return;

      var qtdParcelas = parseInt(match[2]);
      var valorParcelaStr = match[3].replace('R$', '').replace(/\s/g, '').replace('.', '').replace(',', '.');
      var valorParcela = parseFloat(valorParcelaStr);

      if (isNaN(valorParcela) || isNaN(qtdParcelas) || qtdParcelas <= 0) return;

      var valorTotal = valorParcela * qtdParcelas;
      var valorTotalFormatado = valorTotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
      var valorParcelaFormatado = match[3].trim();

      parcela.textContent = 'ou ' + valorTotalFormatado + ' em ' + qtdParcelas + 'x de ' + valorParcelaFormatado + ' sem juros';
      parcela.dataset.parcelaAjustada = 'true';
    });

    /* Página de produto*/
    document.querySelectorAll('.prod-price-container .prod-price-installment, .prod-price-installment').forEach(function (parcela) {
      if (parcela.dataset.parcelaAjustada === 'true') return;
      if (parcela.closest('.prod-showcase-holder')) return;

      var texto = parcela.textContent.trim();
      var match = texto.match(/^(ou\s*)?(\d+)x\s*de\s*(R\$\s*[\d.,]+)\s*(sem juros)?/i);
      if (!match) return;

      var qtdParcelas = parseInt(match[2]);
      var valorParcelaStr = match[3].replace('R$', '').replace(/\s/g, '').replace('.', '').replace(',', '.');
      var valorParcela = parseFloat(valorParcelaStr);

      if (isNaN(valorParcela) || isNaN(qtdParcelas) || qtdParcelas <= 0) return;

      var valorTotal = valorParcela * qtdParcelas;
      var valorTotalFormatado = valorTotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
      var valorParcelaFormatado = match[3].trim();

      parcela.textContent = 'ou ' + valorTotalFormatado + ' em ' + qtdParcelas + 'x de ' + valorParcelaFormatado + ' sem juros';
      parcela.dataset.parcelaAjustada = 'true';
    });
  }

  document.addEventListener('DOMContentLoaded', ajustarTextoParcela);
  window.addEventListener('load', ajustarTextoParcela);
  setTimeout(ajustarTextoParcela, 500);
  setTimeout(ajustarTextoParcela, 1500);
  setTimeout(ajustarTextoParcela, 3000);
  setTimeout(ajustarTextoParcela, 5000);

  var observerParcela = new MutationObserver(function () {
    ajustarTextoParcela();
  });

  if (document.body) {
    observerParcela.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      observerParcela.observe(document.body, { childList: true, subtree: true });
    });
  }
})();


/* Aviso de estoque para produtos sob consulta na página de produto */
(function () {
  function inserirAvisoSobConsulta() {
    /* Verifica se é página de produto sob consulta*/
    var consultSection = document.querySelector('[data-wsjs-product-state="consult"]');
    if (!consultSection) return;
    if (document.querySelector('.aviso-estoque-consulta')) return;

    /* Pegar o WhatsApp do site*/
    var whatsappLink = document.querySelector('.fale-conosco-whatsapp[href]');
    var whatsappHref = whatsappLink ? whatsappLink.getAttribute('href') : 'https://wa.me/5551998706444';

    /* Pegar nome do produto para a mensagem do WhatsApp*/
    var nomeProduto = '';
    var nomeProdEl = document.querySelector('[data-wsjs-product="name"] h1, [data-wsjs-product="name"]');
    if (nomeProdEl) nomeProduto = nomeProdEl.textContent.trim();

    var mensagemWpp = whatsappHref;
    if (mensagemWpp.indexOf('?') === -1) {
      mensagemWpp += '?text=' + encodeURIComponent('Olá! Tenho interesse no produto: ' + nomeProduto);
    }

    /* Criar o aviso*/
    var aviso = document.createElement('a');
    aviso.className = 'aviso-estoque-consulta';
    aviso.href = mensagemWpp;
    aviso.target = '_blank';
    aviso.rel = 'noopener noreferrer';
    aviso.innerHTML = 'Temos este produto em estoque.<br>Entre em contato com a gente para mais informações.';

    /* Inserir antes do formulário de contato*/
    var contactContainer = consultSection.querySelector('.contact-container');
    var prodBlock = consultSection.querySelector('.prod-block-container');

    if (contactContainer) {
      contactContainer.parentNode.insertBefore(aviso, contactContainer);
    } else if (prodBlock) {
      prodBlock.appendChild(aviso);
    }
  }

  document.addEventListener('DOMContentLoaded', inserirAvisoSobConsulta);
  window.addEventListener('load', inserirAvisoSobConsulta);
  setTimeout(inserirAvisoSobConsulta, 1000);
  setTimeout(inserirAvisoSobConsulta, 2000);
  setTimeout(inserirAvisoSobConsulta, 3000);
})();

